import type { Template, TemplateLayer, TemplateSlotLayer } from "../types";

export function getSlotLayers(template: Template): TemplateSlotLayer[] {
  return template.layers.filter((l): l is TemplateSlotLayer => l.type === "slot");
}

export function uniqueSlotIds(template: Template): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const l of template.layers) {
    if (l.type === "slot" && !seen.has(l.id)) {
      seen.add(l.id);
      out.push(l.id);
    }
  }
  return out;
}

export function nextSlotId(template: Template): string {
  const used = new Set(uniqueSlotIds(template));
  let i = 1;
  while (used.has(`slot_${i}`)) i++;
  return `slot_${i}`;
}

export function convertImageToSlot(
  layer: TemplateLayer,
  id: string,
): TemplateSlotLayer | null {
  if (layer.type !== "image") return null;
  const rect = layer.slotRect ?? {
    x: layer.x,
    y: layer.y,
    width: layer.width,
    height: layer.height,
  };
  return {
    name: id,
    ...(layer.group ? { group: layer.group } : {}),
    x: rect.x,
    y: rect.y,
    width: rect.width,
    height: rect.height,
    z: layer.z,
    type: "slot",
    id,
  };
}
